import ContentStudio from './ContentStudio';

export default ContentStudio;
